export const RECT = 'rect'
export const CIRCLE = 'circle'

class Collision {
  constructor () {
    this.colliders = []
  }

  check (collider, group) {
    const others = this.colliders.filter(col => col.group === group)

    let result

    for (const other of others) {
      if (collider === other) continue

      if (collider.shape === RECT && other.shape === RECT)
        result = this.checkRectRect(collider, other)
      else if (collider.shape === CIRCLE && other.shape === CIRCLE)
        result = this.checkCircleCircle(collider, other)
      else if (collider.shape === CIRCLE && other.shape === RECT)
        result = this.checkCircleRect(collider, other)
      else if (collider.shape === RECT && other.shape === CIRCLE)
        result = this.checkCircleRect(other, collider, true)

      if (result) return result
    }

    return false
  }

  checkRectRect (a, b) {
    return false
  }

  checkCircleCircle (a, b) {
    return false
  }

  checkCircleRect (circle, rect, flipped) {
    const distX = Math.abs(circle.position.x - rect.position.x)
    const distY = Math.abs(circle.position.y - rect.position.y)

    if (distX > (rect.width / 2 + circle.radius)) return false
    if (distY > (rect.height / 2 + circle.radius)) return false

    const a = flipped ? rect : circle
    const b = flipped ? circle : rect
    const result = {
      a,
      b,
      intersect: {
        x: a.position.x < b.position.x ? -1 : 1,
        y: a.position.y < b.position.y ? -1 : 1
      }
    }

    if (
      (distX <= (rect.width / 2 + circle.radius)) ||
      (distY <= (rect.height / 2 + circle.radius))
    ) {
      return result
    }

    if ((distX * distX + distY * distY) <= (circle.radius * circle.radius)) {
      return result
    }

    return false
  }
}

const collision = new Collision()

export function useCollision (collider) {
  collision.colliders.push(collider)

  return [
    collision.check.bind(collision, collider),
    function (newCollider) {
      for (const key in newCollider) {
        collider[key] = newCollider[key]
      }
    }
  ]
}

export function checkCollider (collider, group) {
  return collision.check(collider, group)
}
